import React from "react";

//styles
import * as styles from "./Faq.module.css";

// components
import Accordion from "./Accordion";

const Faq = ({ accordionPayload = [], onCtaClick = () => {}, title = "" }) => {
  return (
    <div className={`bgWhiteColor`}>
      <div className={`container ${styles.faq}`}>
        <div className="row">
          <div className="col-12">
            <h2 className={styles.heading}>{title ? title : null}</h2>
          </div>
        </div>

        <div className="row">
          <div className={`col-md-12 ${styles.accordionTop}`}>
            <Accordion
              accordionPayload={accordionPayload}
              onCtaClick={onCtaClick}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Faq;
